import { useQuery, useQueryClient } from 'react-query';

import { RegisteredLocation } from 'types/appState';
import { QUERY_KEY } from 'utils/constants';

interface UseRegisteredLocations {
  selectedLocation: RegisteredLocation | undefined;
  registeredLocations: RegisteredLocation[];
  hasLoaded: boolean;
  removeAllRegisteredLocations: () => void;
}

const useRegisteredLocations = (): UseRegisteredLocations => {
  const queryClient = useQueryClient();

  const { data } = useQuery<unknown, unknown, RegisteredLocation[]>(QUERY_KEY.RegisteredLocations, {
    enabled: false
  });

  const registeredLocations = data ?? [];

  const selectedLocation = registeredLocations.find(location => location.isSelected);

  const removeAllRegisteredLocations = () => {
    queryClient.setQueryData<RegisteredLocation[]>(QUERY_KEY.RegisteredLocations, () => []);
  };

  return {
    selectedLocation,
    registeredLocations,
    hasLoaded: !!registeredLocations,
    removeAllRegisteredLocations
  };
};

export default useRegisteredLocations;
